<template>
  <div :style="{display: visible}">
    <div class="form">
      <div class="label">{{ $t('ticket_types.name') }} *</div>
      <input
        type="text"
        name="name"
        @keyup="(event) => setTabName(event, lang)"
        v-model="ticketData.name[lang]"
      />
    </div>
    <div class="form">
      <div class="label">{{ $t('ticket_types.description') }}</div>
      <input
        type="text"
        name="description"
        @keyup="(event) => setTabDescription(event, lang)"
        v-model="ticketData.description[lang]"
      />
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Tooltip from '../../../../../common/Tooltip';
import "./../styles.scss"
import {storeMixin} from "../../../mixins/storeMixin";
import {configData} from "../../../mixins/configData";

export default {
  props: ["visible", "lang", "name", "description"],
  mixins: [storeMixin, configData],
  name: "LangTab",
  components: {
    Tooltip
  },
  computed: {
    ...mapGetters({
      ticketData: 'tenants/ticketTypes/ticketData',
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tenants/ticket-types/ui/LangTabsBlock/Tab/index.vue